import React from 'react';
import { t } from 'i18next';
import Dropdown from '../../../common/components/Dropdown';

export function AdControlContent(searchText, handleSearchChange, categories, sort, handleSortChange) {
    return (
        <div className="flex items-center gap-2 mt-4 mb-4">
            {/* Search */}
            <div className="flex-1 relative">
                <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                    className="w-full pl-9 pr-4 py-2.5 text-sm bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#147F26] transition-colors"
                    placeholder={t('searchPlaceholder')}
                    value={searchText}
                    onChange={handleSearchChange}
                />
            </div>

            {/* Sort */}
            <div className="flex-shrink-0">
                <Dropdown
                    text={t('sortBy')}
                    options={[t('dateDesSort'), t('dateAscSort'), t('priceAscSort'), t('priceDesSort')]}
                    selected={sort || undefined}
                    onOptionSelect={handleSortChange}
                    width="s200"
                />
            </div>
        </div>
    );
}
